import axios from 'axios';
import { API_GET_REANALYS, API_GET_REANALYS_REPORT, API_GET_REANALYS_REPORT_POINT, API_REANALYS } from '../../constants';
import { download } from '../../utils/common';

export default {
  state: {
    reanalys: [],
    reanalysPreset: []
  },
  mutations: {
    SET_REANALYS: (state, payload) => {
      state.reanalys = payload;
    },
    SET_REANALYS_PRESET: (state, payload) => {
      state.reanalysPreset = payload;
    }
  },
  actions: {
    FETCH_REANALYS: async (context, payload) => {
      try {
        const url = `${API_GET_REANALYS}/${payload.userId}/point?from=${payload.dateStart}&to=${payload.dateEnd}&lat=${payload.latitude}&lon=${payload.longitude}`;
        let reanalysResponse = await axios.get(url);
        const reanalys = reanalysResponse.data.result;

        context.commit('SET_REANALYS', reanalys);
        if (reanalys.latitudes.length) {
          context.commit('PUSH_SUCCESS', 'Реанализ загружен');
        } else {
          context.commit('PUSH_WARNING', 'Нет данных за эти даты');
        }
        return reanalys;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return null;
      }
    },
    FETCH_REANALYSIS_POINTS: async (context, payload) => {
      const url = `${API_REANALYS}/presetId/${payload.presetId}/points`;
      let forecastResponse = await axios.post(url, payload.wapiPolygon2D);
      const response = forecastResponse.data.result;
      return response;
    },
    FETCH_REANALYSIS_PARAMETERS: async () => {
      const url = `${API_REANALYS}/parameters`;
      let response = await axios.get(url);
      const result = response.data.result.data;
      return result;
    },
    FETCH_REANALYS_PRESET: async (context, payload) => {
      try {
        const url = `${API_GET_REANALYS}/${payload.userId}/preset/${payload.presetId}?from=${payload.dateStart}&to=${payload.dateEnd}`;
        let reanalysResponse = await axios.get(url);
        const reanalys = reanalysResponse.data.result;

        context.commit('SET_REANALYS_PRESET', reanalys);
        if (reanalys.latitudes.length) {
          context.commit('PUSH_SUCCESS', 'Реанализ загружен');
        } else {
          context.commit('PUSH_WARNING', 'Нет данных за эти даты');
        }
        return reanalys;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return null;
      }
    },
    REANALYS_REPORT: async (context, payload) => {
      try {
        const url = `${API_GET_REANALYS_REPORT(payload.userId, payload.dateStart, payload.dateEnd, payload.lat, payload.lon)}`;
        const response = await axios.get(url, { responseType: "blob", baseURL: '' });
        download(response);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    REANALYS_REPORT_POINTS: async (context, payload) => {
      try {
        const url = `${API_GET_REANALYS_REPORT_POINT(payload.userId, payload.from, payload.to, payload.presetId)}`;
        const response = await axios.post(url, payload.wapiPolygon2D, { responseType: "blob", baseURL: '' });
        download(response);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    }
  },
  getters: {
    REANALYS: state => {
      return state.reanalys;
    },
    REANALYS_PRESET: state => {
      return state.reanalysPreset;
    },
  }
}